import { roleNamesOf } from '@porotutu/http/vocabulary'
import type { Locale, Translator } from '@porotutu/i18n'
import { type Column, RowLink } from '@porotutu/react/components/DataTable/DataTable'
import { timestampColumns } from '@porotutu/react/components/DataTable/timestampColumns'
import type { ManagedUser, ManagedUserListQuery } from '../queries'

export const columnsFor = (
  t: Translator,
  locale: Locale,
  query: ManagedUserListQuery,
): Array<Column<ManagedUser>> => {
  const { realm, ...search } = query

  return [
    {
      key: 'name',
      header: t('adm.users.columns.name'),
      sortKey: 'name',
      cell: (row) => (
        <RowLink to="/users/$realm/$id" params={{ realm, id: row.id }} search={search}>
          {row.name}
        </RowLink>
      ),
    },
    {
      key: 'email',
      header: t('adm.users.columns.email'),
      sortKey: 'email',
      cell: (row) => row.email,
    },
    {
      key: 'locale',
      header: t('adm.users.columns.locale'),
      cell: (row) => t(`language.${row.locale}.name`),
    },
    {
      key: 'role',
      header: t('adm.users.form.role_label'),
      cell: (row) => roleNamesOf(row.role, t),
    },
    ...timestampColumns<ManagedUser>(t, locale),
  ]
}
